.centeredDay {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.cancelBtn {
    margin: 16px 0;
    border-radius: var(--radius-md, 4px);
    height: 36px;
    border: 1px solid  #f3f4f6;
    background: #f3f4f6;
    padding: 6px 20px !important;
    cursor: pointer;

    /* Shadows/shadow-xs */

    color:  #080828;
    /* Text sm/Semibold */
    font-family: 'Open Sans', sans-serif;
    font-weight: 600 !important;
    line-height: 16px; 
    
}

.applyBtn {
    margin: 16px 32px 16px 12px;
    border-radius: var(--radius-md, 4px);
    border: 1px solid #4149f7;
    padding: 6px 20px !important;
    background:  #4149f7;
    height: 36px;
    cursor: pointer;

    color:  #FFF;
/* Text sm/Semibold */
    font-family: 'Open Sans', sans-serif;
    font-weight: 600 !important;
    line-height: 18px; 
}

.inputMain {
    display: flex;
    padding: 9px 11px 9px 32px;
    justify-content: center;
    align-items: center;
    gap: var(--spacing-xs, 4px);
    transition: all 0.2s ease-in-out;
    font-size: 14px !important;
    line-height: 18px !important; 
    border: none;
    outline: 1px solid  transparent;
    border-radius: 4px;
    background:  #FFF;
    width: 100%;
    box-sizing: border-box;

    &.calendarOpen {
       outline: 1px solid  #D0D5DD;
       border: none;
      //  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(152, 162, 179, 0.14);
    }

    &.inputFilled {
        background-color: #F8F8F9;
    }

    &::placeholder {
        color: #93939F;
    }
}

.inputContainer {
    position: relative;
    display: flex;
    align-items: center;
    flex-grow: 1;
    width: 100%;
    max-width: 260px;
  }
  
  .icon {
    position: absolute;
    left: 8px; /* Adjust as needed */
    pointer-events: none; /* Prevents the icon from blocking input clicks */
  }

  .hiddenSpan {
    visibility: hidden;
    white-space: nowrap;
    position: absolute;
  }

  .fixedCalendar {
    position: absolute !important;
    z-index: 9999; // Ensure it appears above other elements
  }

  // DateRangePicker.module.scss
